module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "siu-wrap"
  }, [_c('div', {
    staticClass: "siu-head"
  }, [_vm._v("Signed in as")]), _vm._v(" "), _c('div', {
    staticClass: "siu-card",
    class: {
      open: _vm.menuOpen
    }
  }, [_c('button', {
    staticClass: "siu-btn",
    on: {
      "click": function($event) {
        _vm.menuOpen = !_vm.menuOpen
      }
    }
  }, [_c('span', {
    staticClass: "siu-avatar"
  }, [_vm._v(_vm._s(_vm.initials))]), _vm._v(" "), _c('span', {
    staticClass: "siu-info"
  }, [_c('span', {
    staticClass: "siu-name"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('span', {
    staticClass: "siu-role"
  }, [_vm._v(_vm._s(_vm.currentRole.shortLabel))])]), _vm._v(" "), _c('svg', {
    staticClass: "siu-caret",
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "6 9 12 15 18 9"
    }
  })])]), _vm._v(" "), (_vm.menuOpen) ? _c('div', {
    staticClass: "siu-menu"
  }, _vm._l((_vm.roles), function(role) {
    return _c('div', {
      key: role.id,
      staticClass: "siu-menu-item",
      class: {
        active: role.id === _vm.currentRole.id
      },
      on: {
        "click": function($event) {
          return _vm.selectRole(role.id)
        }
      }
    }, [(role.id === 'internal') ? _c('svg', {
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
      }
    }), _c('circle', {
      attrs: {
        "cx": "12",
        "cy": "7",
        "r": "4"
      }
    })]) : _c('svg', {
      attrs: {
        "width": "14",
        "height": "14",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
      }
    }), _c('circle', {
      attrs: {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(role.label))])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-67946dad","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/SignedInUserPanel.vue
// module id = g7LH
// module chunks = 1